import axiosInstance from '../api/axiosInstance';

const baseUrl = process.env.REACT_APP_API_URL;

export interface ApiKey {
  id: number;
  name: string;
  keyPrefix: string;
  createdAt: string;
  lastUsedAt: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  user: { id: number; name: string; email: string };
  // first domain of the key's owner, where its submissions land
  domain: string | null;
}

export interface CreatedApiKey extends ApiKey {
  // full key, only ever returned by the create call
  key: string;
}

export interface ApiKeyDto {
  name: string;
  // admins only: the domain admin the key is issued to
  userId?: number;
  expiresAt?: string;
}

export async function getApiKeys(): Promise<ApiKey[]> {
  const response = await axiosInstance.get(`${baseUrl}/admin/api-keys`);
  return response.data;
}

export async function createApiKey(data: ApiKeyDto): Promise<CreatedApiKey> {
  const response = await axiosInstance.post(`${baseUrl}/admin/api-keys`, data);
  return response.data;
}

export async function revokeApiKey(id: number): Promise<ApiKey> {
  const response = await axiosInstance.delete(`${baseUrl}/admin/api-keys/${id}`);
  return response.data;
}
